import React from "react";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import api from "@/services/api";


interface ExportCsvProps {
    apiUrl: string;
    fileName?: string;
}

const ExportCsv: React.FC<ExportCsvProps> = ({
    apiUrl,
    fileName = "export.csv",
}) => {
    const handleExport = async () => {
        try {
            const response = await api.get(apiUrl, {
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", fileName);

            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error(error);
            alert("Export failed");
        }
    };

    return (
        <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            sx={{
                backgroundColor: "#5BC0BE",
                "&:hover": { backgroundColor: "#5BC0BE" },
            }}
            onClick={handleExport}
        >
            Export CSV
        </Button>
    );
};

export default ExportCsv;